import {
  PlainTextField,
  type PlainTextFieldProps,
} from "@smartsuite/react-ui/lib/components/forms/PlainTextField/PlainTextField";

import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { useInputGroupState } from "@smartsuite/react-ui/lib/hooks/useInputGroupState/useInputGroupState";
import React, { type FunctionComponent } from "react";

export type TextFieldInputProps = PlainTextFieldProps;

export const TextFieldInput: FunctionComponent<TextFieldInputProps> = (
  props: TextFieldInputProps,
) => {
  const { state, onFocus, onBlur } = useInputGroupState();

  return (
    <PlainTextField
      {...props}
      state={state}
      active={state === "active"}
      renderLabel={renderFieldLabel}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
};

const renderFieldLabel = (name: string, isActive: boolean): JSX.Element => {
  return (
    <Text
      weight="medium"
      color={isActive ? "link" : "primary"}
      wrapMode="ellipsis"
    >
      {name}
    </Text>
  );
};
